module.exports = __webpack_public_path__ + "static/media/autumnBg.243d7655.jpeg";